import appLogo from "assets/images/jobber_logo.svg";
import AppFrame from "components/AppFrame";
import JobberCallback from "pages/JobberCallback";
import FacebookCallback from "pages/FacebookCallback";
import Error from "pages/Error";
import { JobberFacebookStep1, JobberFacebookStep2, JobberFacebookStep3 } from "pages/Jobber-Facebook";
import {
    Route,
    Routes as ReactRouterRoutes,
} from "react-router-dom";

const Routes = () => {
    return (
        <ReactRouterRoutes>
            <Route element={<AppFrame logo={appLogo} />}>
                <Route path="jobber-facebook-step1" element={<JobberFacebookStep1 />} />
                <Route path="jobber-facebook-step2" element={<JobberFacebookStep2 />} />
                <Route path="jobber-facebook-step3" element={<JobberFacebookStep3 />} />
                <Route path="error" element={<Error />} />
            </Route>
            <Route path="jobber/callback" element={<JobberCallback />} />
            <Route path="facebook/callback" element={<FacebookCallback />} />
        </ReactRouterRoutes>
    );
};

export default Routes;
